export const environment = {
  production: false,
  name: 'develop',
  baseUrl: 'https://amlrequirement.diez.ae/api/',
  version: '0.0.3'
};
